
<div class="main d-flex m-2">
  <div class="menu h-100" :class="nav.class(`toggle`)">
    <div class="accordion" id="accordionMenu">
      <custodians></custodians>
      <repcodes v-if="showRepCodes"></repcodes>
      <schedules></schedules>
      <!-- <templates></templates> -->
    </div>
  </div>
  <div class="toggle" :title="nav.title" v-on:click="nav.toggle()"></div>
  <div class="content flex-grow-1 h-100">
    <repcode v-if="showRepCodes && state && state.repCode"></repcode>
    <custodian v-else></custodian>
  </div>
</div>
